import { MA_DEALS_FIELDS_OPTIONS } from '../constants';
import { MA_DEALS_QUERY } from '../operations';
import { useMaTransactionsContext } from '../../../MaTransactionsContext';
import { useMemo } from 'react';
import { useQuery } from '@apollo/client';

export const useGetDeals = (filters, fields = MA_DEALS_FIELDS_OPTIONS) => {
  const { filterVariables } = useMaTransactionsContext();
  const requestedFields = useMemo(() => {
    return MA_DEALS_FIELDS_OPTIONS.reduce((acc, field) => {
      acc[field] = fields?.includes(field);
      return acc;
    }, {});
  }, [fields]);

  const { data, loading, error } = useQuery(MA_DEALS_QUERY, {
    variables: { filters: { ...filterVariables, ...filters }, ...requestedFields },
  });

  return {
    data: data?.maDeals?.deals || [],
    loading,
    error,
  };
};
